import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edb0aabc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mailListItem" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "username wordHidden" }

import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'
import { getFirstXLetters } from '@/utils/format'


export default /*#__PURE__*/_defineComponent({
  __name: 'mailListItem',
  props: {
    item: {
        type: Object,
        required: true
    }
},
  setup(__props) {

onMounted(() => {
    const bottomDomList = document.querySelectorAll('.bottom') as any
    bottomDomList[0].classList.add('active')
})

const store = useStore()
const handleMailItemClick = (e: any, i: any) => {
    const bottomDomList = document.querySelectorAll('.bottom') as any
    // 先移除所有item的active类名
    bottomDomList.forEach((item: any) => {
        item.classList.remove('active')
    })
    // console.log(e.target.classList, 'target');
    if (Array.from(e.target.classList).includes('username') || Array.from(e.target.classList).includes('avatar')) {
        e.target.parentNode.classList.add('active')
    } else if (Array.from(e.target.classList).includes('text')) {
        e.target.parentNode.parentNode.classList.add('active')
    } else {
        // 再给当前点击项加上active类名
        e.target.classList.add('active')
    }
    store.commit('setClickMailItemDetail', i)
}


const leftMailActiveIndex = ref(0)
const leftMailActiveItem = ref()
// const handleMailItemClick = (item: any, index: any) => {



return (_ctx: any,_cache: any) => {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(__props.item.label), 1),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.item.children, (i, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['bottom', 'hoverStyle']),
        key: index,
        onClick: ($event: any) => (handleMailItemClick($event, i))
      }, [
        _createVNode(_component_el_avatar, { class: "avatar" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getFirstXLetters)(i.name, 3) || '--'), 1)
          ]),
          _: 2
        }, 1024),
        _createElementVNode("div", _hoisted_5, _toDisplayString(i.name || '--'), 1)
      ], 8, _hoisted_3))
    }), 128))
  ]))
}
}

})